import { Apps } from '../apps'
import HttpHelper from './../types/httpHelper'
import { EServices } from './../types/tableHelper'
import LangController from './language/langController'

export default class Extensions {
	static GetItemLink(name: string, appId: number, service: EServices): string {
		const lang: string = LangController.Current === 0 ? 'ru' : 'en'
		const game: string = this.GetGameByAppId(appId)

		let nameEncoded = HttpHelper.GetEncodeText(name)

		const followTo = `item-link/${lang}/${appId}/${service}/${nameEncoded}`

		switch (service) {
			case EServices.Steam:
				return `https://steamcommunity.com/market/listings/${appId}/${nameEncoded}`
			case EServices.TM:
				name = name.replace('&', '')
				return `${this.GetTmSiteByAppId(appId)}?s=price&search=${name}&sd=asc`
			case EServices.Buff:
				return followTo
			case EServices.BuffMarket:
				return followTo
			case EServices.Bitskins:
				return `https://bitskins.com/market/${game}?ref_alias=vvtable&search={"order":[{"field":\"price\",\"order\":\"ASC\"}],\"where\":{\"skin_name\":\"${nameEncoded}\"}}`
			case EServices.C5game:
				return followTo
			case EServices.CSDealsMarket:
				return `https://cs.deals/new?name=${name}&sort=price&sort_desc=0`
			case EServices.DMarket:
				name = name.replace('★', '').replace('™', '').replace('&', '')
				// orderBy/orderDir — сортировка по возрастанию цены. Без них DMarket
				// открывает список в своей сортировке «Рекомендуемое», и нужный лот
				// приходится искать вручную (VVT-233, жалоба пользователя).
				// Имена параметров сняты с их же сетевого запроса: страница кладёт их
				// в api.dmarket.com/exchange/v1/market/items/v2 как есть; по умолчанию
				// там orderBy=personal&orderDir=desc. В самом адресе сайта при ручном
				// выборе сортировки они не появляются, поэтому угадать было нельзя.
				return `https://dmarket.com/${LangController.Current != 1 ? `${lang}/` : ''}ingame-items/item-list/${this.GetDmarketLinkStrByAppId(
					appId
				)}?title=${name}&orderBy=price&orderDir=asc&ref=CHIbd5oOZD`
			case EServices.Igxe:
				return followTo
			case EServices.Shadowpay:
				return appId === Apps.Rust || appId === Apps.CsGo
				? `https://shadowpay.com/${this.GetGameByAppId(appId)}-items?search=${name}&sort_column=price&sort_dir=asc&utm_campaign=E2jz2a5YYsKv8Pj`
				: `https://shadowpay.com/dota-2-items?search=${name}&sort_column=price&sort_dir=asc&utm_campaign=E2jz2a5YYsKv8Pj`
			case EServices.Skinbaron:
				return `https://skinbaron.de/${lang}/${this.GetGameByAppId(appId)}?str=${nameEncoded}&sort=BP`
			case EServices.SnipeSkins:
				return `https://snipeskins.com/buy-rust-skins?search=${name}&sortBy=price&sortDir=asc`
			case EServices.Skinport:
				return appId === Apps.CsGo 
					? `https://skinport.com/market?search=${name}&sort=price&order=asc`
					: `https://skinport.com/${this.GetGameByAppId(appId)}/market?search=${name}&sort=price&order=asc`
			case EServices.Waxpeer:
				nameEncoded = nameEncoded.replace('★', '').replace('™', '')
				return `https://waxpeer.com/?sort=asc&order=price&game=${this.GetGameByAppId(appId)}&search=${nameEncoded}`
			// Exchangers
			case EServices.CSDeals:
				return `https://cs.deals/trade-skins`
			case EServices.CSMoney:
				let gameC = appId === Apps.CsGo ? 'csgo' : 'dota'
				return `https://cs.money/${gameC}/trade/?utm_source=mediabuy&utm_medium=vvtable&utm_campaign=vvtable&utm_content=link&search=${nameEncoded}&sort=price&order=asc`
			case EServices.CSTrade:
				return appId === Apps.CsGo ? `https://cs.trade/trade?market_name=${name}` : "https://cs.trade/#trader";
			case EServices.LF:
				return `https://loot.farm/`
			case EServices.SecretLF:
				return `https://loot.farm/`
			case EServices.Swap:
				return `https://swap.gg/?r=7iA6cHAfwFzjYbKifsmXq`
			case EServices.Tradeit:
				return `https://tradeit.gg/${lang === 'ru' ? 'ru/' : ''}${game}/trade?search=${name}&aff=vvtable`
			case EServices.SecretTradeit:
				return `https://tradeit.gg/${lang === 'ru' ? 'ru/' : ''}${game}/trade?search=${name}&aff=vvtable`
			case EServices.TradeSkinsFast:
				return `https://tradeskinsfast.com/`
			case EServices.VMarket:
				return `https://vmarket.gg/${appId}/${nameEncoded}`
			case EServices.SkinsMonkey:
				return `https://skinsmonkey.com/${lang === 'ru' ? 'ru/' : ''}trade?appId=${appId}&sort=price-asc&q=${name}`
			case EServices.SkinSwap:
				return `https://skinswap.com/trade/?search=${name}&ref=vvtable`
			case EServices.CsFail:
				return `https://5cs.fail/${lang}/`
			case EServices.LisSkins:
				return `https://lis-skins.ru/market/${game}/?query=${nameEncoded}&rf=219131`
			case EServices.SwapMarket:
				return followTo
			case EServices.BitskinsP2P:
				return followTo
			case EServices.CsFloat:
				return `https://csfloat.com/search?sort_by=lowest_price&market_hash_name=${name}`
			case EServices.TMNew:
				return `https://market.csgo.com/${lang}/${nameEncoded}`
			case EServices.CsMoneyMarket:
				return `https://cs.money/${lang}/market/?utm_source=mediabuy&utm_medium=vvtable&utm_campaign=vvtable&utm_content=link&search=${nameEncoded}&sort=price&order=asc`
			case EServices.ITrade:
				return `https://itrade.gg/trade/${Extensions.GetGameByAppId(appId)}?search=${name}&ref=tablevv`
			case EServices.SkinoutMarket:
				return `https://skinout.gg/${lang}/market?search=${nameEncoded}&sort=price_asc`
			case EServices.WhiteMarket:
				return `https://white.market/item?appId=${appId}&nameHash=${nameEncoded}`
			case EServices.AvanMarket:
				{
					const gameA = ({
						[Apps.CsGo]: "cs",
						[Apps.Dota2]: "dota",
						[Apps.Rust]: "rust",
						[Apps.Tf2]: "tf2"
					}[appId])
					
					return `https://avan.market/${lang}/market/${gameA}?name=${name}&r=vvtable`
				}
			case EServices.RapidSkins:
				return `https://rapidskins.com/a/vvtable`
			case EServices.PirateSwap:
				return `https://pirateswap.com/exchanger?ref=vvtable&search=${nameEncoded}`
			// DEBUG (12.08.2026): формат /product/{slug} по URL от Влада:
			// krakatoa.gg/product/patch-aquatic-offensive (только CS2). Игра в путь не входит.
			case EServices.Krakatoa:
				return `https://krakatoa.gg/product/${Extensions.ToItemSlug(name)}`
			case EServices.SkinThunder:
				return `https://skinthunder.com/category?query=${name}&ref=EACMPUCA`
			case EServices.SkinBid:
				return `https://skinbid.com/market?sort=price%23asc&sellType=fixed_price&take=120&skip=0&search=${name}`
			case EServices.Mannco:
				let gameB = appId === Apps.CsGo ? "cs2" : appId === Apps.Dota2 ? "dota" : appId === Apps.Rust ? "rust" : "tf2"
				return `https://mannco.store/${gameB}?search=${name}&ref=yzg5mty`
      		case EServices.HaloSkins:
				return followTo
			case EServices.SkinFlow:
				return `https://skinflow.gg/trade?search=${name}`
			case EServices.SkinDeck:
				return `https://skindeck.com/sell?tab=withdraw`
			case EServices.CSGO500:
				const gameS = appId === Apps.CsGo ? "cs2" : "rust"
			
				return `https://csgo500.com/p2p/${gameS}/withdraw`
			case EServices.Youpin898:
				return followTo
			case EServices.ManncoTrade:
				return 'https://mannco.trade/'
			// DEBUG (12.08.2026): формат /{lang}/{game}/item/{slug} по URL от Влада:
			// rustskins.com/ru/rust/item/punishment-mask. Игра: rust→rust, CS2→cs2
			// (у них новый сайт на "cs2", не "csgo" — НЕ проверено на живом CS2-предмете).
			case EServices.RustSkins:
				return `https://rustskins.com/${lang}/${appId === Apps.CsGo ? 'cs2' : 'rust'}/item/${Extensions.ToItemSlug(name)}`
			case EServices.SteamTrader:
				return `https://steam-trader.net/en/${game}/${nameEncoded}`
			case EServices.SkinPlace:
				return `https://skin.place/market?game=${game}&search=${nameEncoded}&utm_campaign=wEynGcc56NPPLtl`
			// DEBUG (12.08.2026): имя в ПУТИ, а не query. URL от Влада:
			// aim.market/ru/buy/csgo/Sticker%20%7C%20Titan%20(Holo)%20%7C%20Katowice%202014
			case EServices.AimMarket:
				return `https://aim.market/${lang}/buy/${game}/${nameEncoded}`
			case EServices.ClashGg:
				return `https://stash.clash.gg/marketplace`
			case EServices.DropSkin:
				return `https://dropskin.com/${lang}/skin-changer`
			// DEBUG (12.08.2026): у Skinrave НЕТ отдельной страницы предмета — маркет
			// это SPA с плашками на одной странице (Влад проверил, URL предмета не даётся).
			// Оставляем маркет с фильтром по имени — открывает поиск, дальше вручную.
			case EServices.Skinrave:
				return `https://skinrave.gg/${lang}/marketplace?active-tab=market&filter=${nameEncoded}`
				case EServices.CsGoEmpire:
					return `https://csgoempire.com/withdraw/steam/market?search=${nameEncoded}`
				case EServices.Skinland:
					// skin.land разделён по играм: /market/csgo|dota2|rust — слаги совпадают с GetGameByAppId
					return `https://skin.land/market/${game}/?search=${nameEncoded}`
				case EServices.Csgoroll:
					// раздел P2P-вывода переехал: /withdraw/csgo/p2p с сентября 2026 отдаёт 404
					// «The page you are looking for does not exist», витрина на /trade/market
					// (по той же причине чинили userscript парсера csgoroll)
					return `https://www.csgoroll.com/trade/market`
			default:
				throw Error('Unknown service')
		}
	}

	static GetReferralLink(service: EServices): string {
		const lang: string = LangController.Current === 0 ? 'ru' : 'en'

		switch (service) {
			case EServices.Steam:
				return 'https://steamcommunity.com/market'
			case EServices.SnipeSkins:
				return `https://snipeskins.com`
			case EServices.TM:
				return 'https://market.csgo.com'
			case EServices.Buff:
				return 'https://buff.163.com'
			case EServices.BuffMarket:
				return 'https://buff.market/r/U1093452240'
			case EServices.Bitskins:
				return 'https://bitskins.com/?ref_alias=vvtable'
			case EServices.C5game:
				return 'https://www.c5game.com'
			case EServices.CSDealsMarket:
				return 'https://cs.deals/new'
			case EServices.DMarket:
				return `https://dmarket.com/${LangController.Current != 1 ? `${lang}/` : ''}?ref=CHIbd5oOZD`
			case EServices.Igxe:
				return 'https://www.igxe.cn'
			case EServices.Shadowpay:
				return `https://shadowpay.com?utm_campaign=E2jz2a5YYsKv8Pj`
			case EServices.Skinbaron:
				return `https://skinbaron.de/${lang}`
			case EServices.Skinport:
				return 'https://skinport.com'
			case EServices.Waxpeer:
				return 'https://waxpeer.com/r/vvtable'
			// Exchangers
			case EServices.CSDeals:
				return `https://cs.deals/trade-skins`
			case EServices.CSMoney:
				return `https://cs.money/${lang}/trade`
			case EServices.CSTrade:
				return `https://cs.trade/#trader`
			case EServices.LF:
				return `https://loot.farm/`
			case EServices.SecretLF:
				return `https://loot.farm/`
			case EServices.Swap:
				return `https://swap.gg/?r=7iA6cHAfwFzjYbKifsmXq`
			case EServices.Tradeit:
				return `https://tradeit.gg/${lang === 'ru' ? 'ru/' : ''}csgo/trade?aff=vvtable`
			case EServices.SecretTradeit:
				return `https://tradeit.gg/${lang === 'ru' ? 'ru/' : ''}csgo/trade?aff=vvtable`
			case EServices.TradeSkinsFast:
				return `https://tradeskinsfast.com`
			case EServices.VMarket:
				return 'https://vmarket.gg'
			case EServices.SkinsMonkey:
				return `https://skinsmonkey.com/${lang === 'ru' ? 'ru/' : ''}trade`
			case EServices.SkinSwap:
				return `https://skinswap.com/trade/?ref=vvtable`
			case EServices.CsFail:
				return `https://5cs.fail/${lang}/`
			case EServices.LisSkins:
				return 'https://lis-skins.ru/?rf=219131'
			case EServices.SwapMarket:
				return 'https://market.swap.gg'
			case EServices.DMarketP2P:
				return 'https://dmarketp2p.com'
			case EServices.BitskinsP2P:
				return 'https://p2p.bitskins.com/?ref_alias=vvtable'
			case EServices.CsFloat:
				return 'https://csfloat.com/'
			case EServices.TMNew:
				return 'https://market.csgo.com/'
			case EServices.CsMoneyMarket:
				return `https://cs.money/${lang}/market/buy/`
			case EServices.ITrade:
				return 'https://itrade.gg?ref=tablevv'
			case EServices.SkinoutMarket:
				return 'https://skinout.gg/'
			case EServices.WhiteMarket:
				return 'https://white.market/invite/1f0158a7a81f0797'
			case EServices.AvanMarket:
				return 'https://avan.market/ru/market?r=vvtable'
			case EServices.RapidSkins:
				return 'https://rapidskins.com/a/vvtable'
			case EServices.PirateSwap:
				return `https://pirateswap.com/exchanger?ref=vvtable`
			case EServices.Krakatoa:
				return `https://krakatoa.gg/`
			case EServices.SkinThunder:
				return 'https://skinthunder.com/?ref=EACMPUCA'
			case EServices.SkinBid:
				return `https://skinbid.com/market`
			case EServices.Mannco:
				return `https://mannco.store/?ref=yzg5mty`
      		case EServices.HaloSkins:
				return `https://www.haloskins.com/`
			case EServices.SkinFlow:
				return `https://skinflow.gg/`
			case EServices.SkinDeck:
				return `https://skindeck.com/sell?tab=withdraw`
			case EServices.CSGO500:		
				return `https://csgo500.com`
			case EServices.Youpin898:
				return 'https://www.youpin898.com/'
			case EServices.ManncoTrade:
				return 'https://mannco.trade/'
			case EServices.RustSkins:
				return 'https://rustskins.com'
			case EServices.SteamTrader:
				return 'https://steam-trader.net/en/tf2'
			case EServices.SkinPlace:
				return 'https://skin.place?utm_campaign=wEynGcc56NPPLtl'
			case EServices.AimMarket:
				return 'https://aim.market/p/vvtable'
			case EServices.ClashGg:
				return 'https://stash.clash.gg/marketplace'
			case EServices.DropSkin:
				return 'https://dropskin.com'
			case EServices.Skinrave:
				return 'https://skinrave.gg'
				case EServices.CsGoEmpire:
					return 'https://csgoempire.com'
				case EServices.Skinland:
					return 'https://skin.land'
				case EServices.Csgoroll:
					return 'https://www.csgoroll.com'
			default:
				throw Error('Unknown service')
		}
	}

	static GetProfileAvatarLink(imageHash: string, fullSize: boolean = false): string {
		return `https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/3d/${imageHash}_${fullSize ? 'full' : 'medium'}.jpg`
	}
	static GetItemImageLink(imageHash: string, size: number = 128): string {
		return `https://community.akamai.steamstatic.com/economy/image/${imageHash}/${size}fx${size}f`
	}

	static GetGameByAppId(appId: number): string {
		switch (appId) {
			case Apps.CsGo:
				return 'csgo'
			case Apps.Dota2:
				return 'dota2'
			case Apps.Tf2:
				return 'tf2'
			case Apps.Rust:
				return 'rust'
			default:
				throw Error('Unknown game')
		}
	}

	// DEBUG (12.08.2026): slug для сайтов, где предмет открывается kebab-case путём,
	// а не query. Правило выведено из реальных URL, присланных Владом:
	//   RustSkins "Punishment Mask"           → rustskins.com/ru/rust/item/punishment-mask
	//   Krakatoa  "Patch | Aquatic Offensive" → krakatoa.gg/product/patch-aquatic-offensive
	// Проверено ТОЛЬКО на этих двух. На именах с ★/™/StatTrak/скобками/цифрами (AK-47)
	// поведение не проверялось — если их slug строится иначе, ссылка даст 404.
	static ToItemSlug(name: string): string {
		return name
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '')
	}
	static GetGamePrettyByAppId(appId: number): string {
		switch (appId) {
			case Apps.CsGo:
				return 'CS2'
			case Apps.Dota2:
				return 'Dota 2'
			case Apps.Tf2:
				return 'TF2'
			case Apps.Rust:
				return 'Rust'
			default:
				throw Error('Unknown game')
		}
	}

	static GetTmSiteByAppId(appId: number): string {
		switch (appId) {
			case Apps.CsGo:
				return 'https://market-old.csgo.com/'
			case Apps.Dota2:
				return 'https://market.dota2.net/'
			case Apps.Tf2:
				return 'https://tf2.tm/'
			case Apps.Rust:
				return 'https://rust.tm/'
			default:
				throw Error('Unknown game')
		}
	}
	static GetDmarketLinkStrByAppId(appId: number): string {
		switch (appId) {
			case Apps.CsGo:
				return 'csgo-skins'
			case Apps.Dota2:
				return 'dota2-skins'
			case Apps.Tf2:
				return 'tf2-skins'
			case Apps.Rust:
				return 'rust-skins'
			default:
				throw Error('Unknown game')
		}
	}

	static NickLetters(): number {
		return 24
	}
	static GetShortNickname(nickname: string): string {
		return nickname?.length > this.NickLetters() ? nickname.substring(0, this.NickLetters()) + '...' : nickname
	}

	static Round(num: number) {
		return Math.round((num + Number.EPSILON) * 100) / 100
	}

	static Floor(num: number) {
		return Math.floor((num + Number.EPSILON) * 100) / 100
	}

	static Ceil(num: number) {
		return Math.ceil((num + Number.EPSILON) * 100) / 100
	}

	static GetEnumNames(enumType): string[] {
		const arr: string[] = []

		for (let enumMember in enumType) {
			const isValueProperty = parseInt(enumMember, 10) >= 0
			if (isValueProperty) {
				arr.push(enumType[enumMember])
			}
		}

		return arr
	}

	static GetEnumValues(enumType): number[] {
		const arr: number[] = []

		for (let enumMember in enumType) {
			const isValueProperty = parseInt(enumMember, 10) >= 0
			if (isValueProperty) {
				arr.push(parseInt(enumMember, 10))
			}
		}

		return arr
	}

	static ZeroPad(num: number, numZeros: number) {
		var an = Math.abs(num)
		var digitCount = 1 + Math.floor(Math.log(an) / Math.LN10)
		if (digitCount >= numZeros) {
			return num
		}
		var zeroString = Math.pow(10, numZeros - digitCount)
			.toString()
			.substring(1)
		return num < 0 ? '-' + zeroString + an : zeroString + an
	}

	static GetRandomInt(max: number) {
		return Math.floor(Math.random() * max)
	}

	static StringFormat(text: string, ...params: any[]): string {
		return text.replace(/{(\d+)}/g, function(match, number) { 
			return typeof params[number] != 'undefined'
				? params[number]
				: match
			;
		});
	}
}
